export default {
    all: { method: 'GET', url: 'forma-pagamento/all' },
    active: { method: 'GET', url: 'forma-pagamento/active' },
    get: { method: 'GET', url: 'forma-pagamento/get{/id}' },
    create: { method: 'POST', url: 'forma-pagamento' },
    update: { method: 'PUT', url: 'forma-pagamento' },
    inactive: { method: 'DELETE', url: 'forma-pagamento/{/id}' },
};